// #ux-redesign-start: AuthTerms (Paso 5 — Auth redesign)
// Checkbox de aceptación de términos para el RegisterPage.
//   - Usa Checkbox del DS.
//   - Inline link "AGB" abre un Modal del DS con TermsCardContent (mismo
//     contenido legal, mismo TranslatorProvider del namespace `terms/<lang>`).
//
// PORTABILIDAD: trasplantable a Web-Patients.
// ─────────────────────────────────────────────────────────────────────────────

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { TranslatorProvider } from 'react-translate';
import { Checkbox, Modal, Button } from 'components/ds';
import TermsCardContent from 'views/Components/Terms/TermsCardContent';

const AuthTerms = ({ t, register, error }) => {
  const { language } = useSelector((state) => state.userReducer);
  const [open, setOpen] = useState(false);

  return (
    <>
      <Checkbox
        name="terms"
        innerRef={register}
        error={error}
        label={
          <span>
            {t('terms-1')}{' '}
            <button
              type="button"
              className="ds-auth__inline-link"
              onClick={(e) => {
                e.preventDefault();
                setOpen(true);
              }}
            >
              {t('terms-2')}
            </button>
            {t('terms-3')}
          </span>
        }
      />
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title={t('terms-2')}
        size="lg"
      >
        <TranslatorProvider
          translations={require(`assets/i18n/terms/${language || 'de'}.json`)}
        >
          <TermsCardContent />
        </TranslatorProvider>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setOpen(false)}>
            {t('hide-terms')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

AuthTerms.propTypes = {
  t: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  error: PropTypes.node,
};

export default AuthTerms;
// #ux-redesign-end
